import React from "react";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as Variable from "./Variable";

import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import * as CommonFunctions from "./functions/commonFunctions";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import * as GC from "../../../common/common";
import { CONSTS } from "../../../common/const";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
  }

  reloadData(page_number, ids, short_type, direction, field, content = []) {
    var model;
    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [],
          sorting: [],
          definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
        };
      } else {
        model = {
          content: content,
          definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
          sorting: [],
        };
        window.$nature_protection_result = [];
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
        };
      } else {
        model = {
          content: content,
          definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
      }
    }
    window.$nature_protection_lastUsedTableFilter = model;
    this.fillTable(model, page_number);
    this.fillFilterColumns();
  }

  fillFilterColumns() {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
    };
    $.each(window.$nature_protection_columnList, function (index, data) {
      if (data.id !== "" && data.filter === true) {
        omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$nature_protection_token
          )
          .then((result) => {
            CallBackFunctions.FillFilterColumnsCallBack(data, result);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  fillTable(model, page_number) {
    var that = this;
    window.$nature_protection_lastUsedTableFilter = model;

    window.$nature_protection_treeChangeStatus = false;
    window.$nature_protection_scroll_change = false;

    omnimap
      .FillTableAction(model, page_number, window.$nature_protection_token)
      .then((result) => {
        CallBackFunctions.FillTableCallBack(
          result,
          page_number,
          window.$nature_protection_columnListPure
        );
      });
  }

  addContentAndFillTable(key, value) {
    var hasRow = $.grep(window.$nature_protection_filterContent, function (v) {
      return v.key === key;
    });
    if (hasRow.length > 0) {
      window.$nature_protection_filterContent = $.grep(
        window.$nature_protection_filterContent,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null) {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$nature_protection_filterContent.push(contentModel);
    }

    this.reloadData(
      1,
      window.$nature_protection_result,
      null,
      null,
      null,
      window.$nature_protection_filterContent
    );
  }

  searchFilterColumns(key, searchId) {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
    };

    omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$nature_protection_token
      )
      .then((result) => {
        CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  GetActionsOfRow(rowIds) {
    omnimap
      .GetActionsOfRowAction(rowIds, window.$nature_protection_token)
      .then(CallBackFunctions.GetActionsOfRowCallback)
      .catch((error) => {
        console.log(error);
      });
  }

  getNatureProtectionByTree() {}

  /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
  treeParser = (data, beheereenheid) => {
    var treeClass = document.getElementsByClassName("act");

    if (treeClass && treeClass) {
      for (let i = 0; i < treeClass.length; i++) {
        const div = treeClass[i];
        if (div.tagName === "DIV") {
          window.$nature_protection_result.push({
            id: div.dataset.id,
            type: div.dataset.type,
          });
        }
      }
    }

    // const that = this;
    // data.forEach(function (element) {
    //   if (element.name === beheereenheid) {
    //     if (element.parentfolder != undefined) {
    //       let selectedItem = window.$nature_protection_treeListPure.find(
    //         (x) =>
    //           x.content["algemeen-soort"] === element.parentfolder ||
    //           x.content["algemeen-nederlandsenaam"] === element.parentfolder ||
    //           x.content["algemeen-naamperiode"] === element.parentfolder
    //       );
    //       if (selectedItem) {
    //         for (let prop in selectedItem.content) {
    //           if (
    //             selectedItem.content[prop] &&
    //             selectedItem.content[prop] === element.parentfolder
    //           ) {
    //             window.$nature_protection_result.push({
    //               id: element.parentfolder,
    //               type: prop,
    //             });
    //           }
    //         }
    //       }
    //       // window.$nature_protection_result.push({
    //       //   id: element.id,
    //       //   type: element.type,
    //       // });
    //       // that.treeParser(element.children, element.id);
    //     }
    //     window.$nature_protection_result.push({
    //       id: element.id,
    //       type: element.type,
    //     });
    //   } else if (element.children && element.children.length > 0) {
    //     that.treeParser(element.children, beheereenheid);
    //   }
    // });
  };

  //filter
  filterNatureProtection() {
    var nederlandsenaam = {
      values: [],
      key: "algemeen-nederlandsenaam",
      and_or: "AND",
      datatype: "STRING",
    };

    var naamperiode = {
      values: [],
      key: "algemeen-naamperiode",
      and_or: "AND",
      datatype: "STRING",
    };
    var soort = {
      values: [],
      key: "algemeen-soort",
      and_or: "AND",
      datatype: "STRING",
    };

    for (let i = 0; i < window.$nature_protection_result.length; i++) {
      const element = window.$nature_protection_result[i];
      if (element.type === "algemeen-nederlandsenaam") {
        nederlandsenaam.values.push(element.id);
      } else if (element.type === "algemeen-naamperiode") {
        naamperiode.values.push(element.id);
      } else if (element.type === "algemeen-soort") {
        soort.values.push(element.id);
      }
    }

    var content = [nederlandsenaam, naamperiode, soort];
    // if (window.$nature_protection_result.length == 1) {
    //   content = [
    //     {
    //       values: [this.props.location.state.id],
    //       key: "algemeen-naamperiode",
    //       and_or: "AND",
    //       datatype: "STRING",
    //     },
    //   ];
    // }
    return content;
  }

  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        var model = {
          content: [],
          definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
        };
        // that.setState({ lastUsedTableFilter: model });
        window.$nature_protection_lastUsedTableFilter = model;

        that.reloadData(1);
        document.getElementById("tree-parent-id").setAttribute("value", "");

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        if (that.props.location.state.isDidUpdate == "0038") {
          var model = {
            content: [],
            definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
          };
          // that.setState({ lastUsedTableFilter: model });
          that.reloadData(1);
        } else {
          window.$nature_protection_result = [];
          let selectedItem = window.$nature_protection_treeListPure.filter(
            (x) =>
              x.content["algemeen-soort"] === that.props.location.state.id ||
              x.content["algemeen-nederlandsenaam"] ===
                that.props.location.state.id ||
              x.content["algemeen-naamperiode"] === that.props.location.state.id
          );
          if (selectedItem.length > 0) {
            for (let prop in selectedItem[0].content) {
              if (
                selectedItem[0].content[prop] &&
                selectedItem[0].content[prop] === that.props.location.state.id
              ) {
                window.$nature_protection_result.push({
                  id: that.props.location.state.id,
                  type: prop,
                });
              }
            }
            // document.writeln(`${prop}: ${}<br/>`);
          }
          // window.$nature_protection_result.push(that.props.location.state.id);
          this.treeParser(
            that.props.location.state.TreeList,
            that.props.location.state.id
          );

          if (that.props.location.state.treeLocation !== "modal") {
            that.reloadData(
              1,
              window.$nature_protection_result,
              null,
              null,
              null,
              this.filterNatureProtection()
            );
          }
        }
      }
      //* sayfa f5 ile yenilendiğinde prev props:
      //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
      else if (window.performance) {
        if (performance.navigation.type == 1) {
          if (that.props.location.state.isDidUpdate == "0038") {
            var model = {
              content: [],
              definitions: [process.env.REACT_APP_CATALOG_NATURE_PROTECTION],
            };
            // that.setState({ lastUsedTableFilter: model });
            that.reloadData(1);
          } else {
            window.$nature_protection_result = [];
            let selectedItem = window.$nature_protection_treeListPure.filter(
              (x) =>
                x.content["algemeen-soort"] === that.props.location.state.id ||
                x.content["algemeen-nederlandsenaam"] ===
                  that.props.location.state.id ||
                x.content["algemeen-naamperiode"] ===
                  that.props.location.state.id
            );
            if (selectedItem.length > 0) {
              for (let prop in selectedItem[0].content) {
                if (
                  selectedItem[0].content[prop] &&
                  selectedItem[0].content[prop] === that.props.location.state.id
                ) {
                  window.$nature_protection_result.push({
                    id: that.props.location.state.id,
                    type: prop,
                  });
                }
                // document.writeln(`${prop}: ${}<br/>`);
              }
            }
            // window.$nature_protection_result.push(that.props.location.state.id);
            this.treeParser(
              that.props.location.state.TreeList,
              that.props.location.state.id
            );

            if (that.props.location.state.treeLocation !== "modal") {
              that.reloadData(
                1,
                window.$nature_protection_result,
                null,
                null,
                null,
                this.filterNatureProtection()
              );
            }
          }
        } else {
          alert("This page is not reloaded");
        }
      }
    } else {
      window.$nature_protection_result = [];
      window.$nature_protection_result.push(that.props.location.state.id);
      this.treeParser(
        that.props.location.state.TreeList,
        that.props.location.state.id
      );

      if (that.props.location.state.treeLocation !== "modal") {
        that.reloadData(
          1,
          window.$nature_protection_result,
          null,
          null,
          null,
          this.filterNatureProtection()
        );
      }
      $("#cover-spin").hide(0);
    }
  }
  componentWillUnmount() {
    // window.$nature_protection_lastUsedTableFilter = [];
  }
  async componentDidMount() {
    var that = this;

    /***************************************************************************************/
    /**FREE FORMAT */
    var tableHeaderItems;
    var userColumnResult = await omnimap.GetFreeFormatByIdAction(
      CONSTS.USER_ID_STORE
    );
    // userda column sort id'si varmı ?
    if (userColumnResult.meta.total_found == 0) {
      var user = window.localStorage.getItem("accessToken");
      window.$mm_management_units_column_order_users.client_identification =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.code =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.data.users.push({
        user_id: user.identification,
        id_stores: {
          table_column_order: GC.uuidv4(),
        },
      });
      omnimap
        .GetFreeFormatAction(
          "",
          "POST",
          window.$mm_management_units_column_order_users
        )
        .then(() => {
          // GC.sleep(1500).then(() => this.fillTable());
        });
    }
    //userda column sort id'si var sa else geç
    else {
      let result = await omnimap.GetFreeFormatByIdAction(
        CONSTS.COLUMN_ORDER_CATALOG_NATURE_PROTECTION
      );

      // bu sayfanın column sort'u var mı?
      if (result.meta.total_found == 0) {
        window.$nature_protection_column_order_post_model.client_identification =
          CONSTS.COLUMN_ORDER_CATALOG_NATURE_PROTECTION;
        window.$nature_protection_column_order_post_model.code =
          CONSTS.COLUMN_ORDER_CATALOG_NATURE_PROTECTION;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
            window.$nature_protection_column_order_post_model
          )
          .then(() => {
            window.location.reload();
          });
      }
      // bu sayfanın column sort'u varsa else'e geç
      else {
        //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

        let result = await omnimap.GetFreeFormatByIdAction(
          CONSTS.COLUMN_ORDER_CATALOG_NATURE_PROTECTION,
          "GET"
        );

        await this.setState({
          columnOrderIdentification: result.data[0].identification,
          columnOrderReference: result.data[0].reference,
        });

        result = await result.data[0].data.table_sorting.find(
          (x) => x.name === "catalog>nature-protection"
        );

        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled" style={{ width: "1%" }}>
              <div id="beheer-short-table">
                <div id="beheer-svg" className="maatregelen-svg"></div>
                <div id="beheer-snowflake" className="snowflake"></div>
              </div>
            </th>
          ) : (
            <th key={item}>{item}</th>
          )
        );
        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$nature_protection_columnListPure = result;
      }
    }
    /***************************************************************************************/

    if (window.$nature_protection_token == null) {
      window.$nature_protection_token = GC.GetToken().then((token) => {
        window.$nature_protection_token = token;
        window.$nature_protection_lastUsedTableFilter.content
          ? that.fillTable(window.$nature_protection_lastUsedTableFilter, 1)
          : this.reloadData(1);
      });
    } else {
      window.$nature_protection_lastUsedTableFilter.content
        ? that.fillTable(window.$nature_protection_lastUsedTableFilter, 1)
        : this.reloadData(1);
    }

    ColumnList.forEach(function (item) {
      if (item.name == "catalog>nature-protection") {
        window.$nature_protection_columnList = item["column-list"];
      }
    });
    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      searching: false,
      paging: false,

      scrollX: true, //"500px",
      scrollY: "calc(100vh - 330px)",

      scrollCollapse: true,

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      destroy: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      colReorder: {
        fixedColumnsLeft: 1
      },
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_CATALOG_NATURE_PROTECTION
        );
        window.$nature_protection_columnListPure = result;
      },
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$nature_protection_columnListPure.column_list[idx] ===
          "checkbox" ||
        window.$nature_protection_columnListPure.column_list[idx] === "active"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0

    $(".dataTables_scrollBody").scroll(function () {
      if (window.$nature_protection_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          if (document.getElementById("tableSide").className !== "d-none") {
            if (
              `/${this.baseURI.split("/")[3]}/${this.baseURI.split("/")[4]}` ===
                that.props.location.pathname &&
              window.$nature_protection_table_total_row_count >
                process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
            ) {
              $("#cover-spin").show(0);
              window.$nature_protection_page_number++;
              that.fillTable(
                window.$nature_protection_lastUsedTableFilter,
                window.$nature_protection_page_number
              );
            }
          } else window.$nature_protection_scroll_change = true;
        }
      }
      // var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();

      // if (window.$nature_protection_scroll_change) {
      //   if (
      //     $(".dataTables_scrollBody").prop("scrollHeight") -
      //       $(".dataTables_scrollBody").scrollTop() <=
      //     $(".dataTables_scrollBody").height() + buffer
      //   ) {
      //     lastScrollControl = 0;
      //   }
      // }
      // if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
      //   if (window.$nature_protection_scroll_change) {
      //     if (
      //       $(".dataTables_scrollBody").prop("scrollHeight") -
      //         $(".dataTables_scrollBody").scrollTop() <=
      //       $(".dataTables_scrollBody").height() + buffer
      //     ) {
      //       if (document.getElementById("tableSide").className !== "d-none") {
      //         if (
      //           `/${this.baseURI.split("/")[3]}/${
      //             this.baseURI.split("/")[4]
      //           }` === that.props.location.pathname &&
      //           window.$nature_protection_table_total_row_count >
      //             process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
      //         ) {
      //           $("#cover-spin").show(0);
      //           window.$nature_protection_page_number++;
      //           that.fillTable(
      //             window.$nature_protection_lastUsedTableFilter,
      //             window.$nature_protection_page_number
      //           );
      //         }
      //       } else window.$nature_protection_scroll_change = true;
      //     }
      //   }
      // }
    });
    $(document).on("click", "#mappen_beheren", function () {
      $("#mappen_beheren_modal").modal("show");
    });
    /*** SETUP - ADD A TEXT INPUT TO EACH FOOTER CELL ***/
    $("#example thead tr").clone(true).appendTo("#example thead");
    $("#example thead tr th").removeClass("sorting_asc");

    $(table.table().header()).addClass("scrollabe-datatable");

    document.getElementsByClassName("scrollabe-datatable")[0].parentElement.id =
      "scrollabe-datatable-id";

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title) {
        var row = $.grep(window.$nature_protection_columnList, function (v) {
          return String(v.name).toLowerCase() === String(title).toLowerCase();
        });
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (this.innerHTML.includes("checkAll")) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (this.innerHTML.includes("snowflake")) {
        $(this).html(
          '<div class="refresh"> </div>' +
            /**popup filter1 */
            '<div class="filter-popup">' +
            '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
            "</div>"
        );
      } else {
        $(this).html("");
      }
    });

    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var row_index = table.column(this).index();

      if (row_index != undefined && row_index != 0) {
        var nRow = $("#scrollabe-datatable-id thead tr")[0];
        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "col-search ui-autocomplete-input" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (row_index) {
            if (this.className == "sorting_disabled") {
              this.className = "sorting_asc";
              var row;
              $.each(
                window.$nature_protection_columnList,
                function (index, data) {
                  if (data.row == row_index) {
                    row = data;
                  }
                }
              );
              that.reloadData(
                1,
                window.$nature_protection_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$nature_protection_filterContent
              );
            } else if (this.className == "sorting_asc") {
              this.className = "sorting_desc";
              var row;
              $.each(
                window.$nature_protection_columnList,
                function (index, data) {
                  if (data.row == row_index) {
                    row = data;
                  }
                }
              );
              that.reloadData(
                1,
                window.$nature_protection_result,
                row.shortType,
                "DESCENDING",
                row.shortField,
                window.$nature_protection_filterContent
              );
            } else if (this.className == "sorting_desc") {
              this.className = "sorting_asc";
              var row;
              $.each(
                window.$nature_protection_columnList,
                function (index, data) {
                  if (data.row == row_index) {
                    row = data;
                  }
                }
              );
              that.reloadData(
                1,
                window.$nature_protection_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$nature_protection_filterContent
              );
            }
          }

          window.$nature_protection_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");

    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      $.each(window.$nature_protection_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$nature_protection_selectedRow = data;
          that.props.history.push(
            "/catalog/nature-protection/detail/" + rowId,
            {
              rowData: data,
            }
          );
        }
      });

      // CommonFunctions.fillDetail();
      // $("#tableSide").addClass("d-none");
      // $("#detailSide").removeClass("d-none");
    });

    /*** ---OPTION TO ALLOW SELECTING ROWS BY CLICKING ON ROW BESIDES CHECKBOX--- ***/
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });

    $("#algemeen-wetenschappelijkenaam").autocomplete({
      source: window.$nature_protection_search_filter_wetenschappelijkenaam,
      select: function (event, ui) {
        that.addContentAndFillTable(
          "algemeen-wetenschappelijkenaam",
          ui.item.value
        );
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-nederlandsenaam").autocomplete({
      source: window.$nature_protection_search_filter_nederlandsenaam,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-nederlandsenaam", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-wet").autocomplete({
      source: window.$nature_protection_search_filter_wet,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-wet", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-ovg").autocomplete({
      source: window.$nature_protection_search_filter_ovg,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-ovg", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-naamperiode").autocomplete({
      source: window.$nature_protection_search_filter_naamperiode,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-naamperiode", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-soort").autocomplete({
      source: window.$nature_protection_search_filter_soort,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-soort", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-wetenschappelijkenaam").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-nederlandsenaam").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-wet").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-ovg").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-naamperiode").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-soort").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.fillTable(window.$nature_protection_lastUsedTableFilter, 1);
      window.$nature_protection_page_number = 1;
      // that.reloadData(1);
    }

    window.$nature_protection_refresh = handleRefresh;
    $(".refresh").click(handleRefresh);

    $("div.popup").click(function () {
      var test = this;
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      // that.setState({ selectedIds: selectedIds });
      window.$nature_protection_selectedIds = selectedIds;
      that.GetActionsOfRow(selectedIds.join(","));
    });

    $(document).on("click", "#verwijderen", function () {
      if (window.$nature_protection_selectedIds == 0) {
        alert("rows not selected");
      } else {
        $("#management-units-mappen_beheren_delete_modal").modal("show");
      }
    });

    function koppelAanFolderCallBack() {
      GC.sleep(2000).then(() => {
        $("#cover-spin").hide(0);

        $("#modal_koppel_aan_folder").modal("hide");
        that.reloadData(1);
      });
    }

    $(document).on("click", "#management-units-koppel-aan-folder", () => {
      $("#cover-spin").show(0);

      var model = {
        action: "ADD",
        contextRol: "Beheereenheid zit in folder",
        folder: document.getElementById("tree-parent-id").value,
      };
      GC.StartActivity(
        model,
        window.$nature_protection_selectedIds,
        "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
        koppelAanFolderCallBack(),
        window.$nature_protection_token
      );
    });

    $(document).on("click", ".mm_work_plans_action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$mm_work_plans_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              {this.state.columnList}
              {/* <th className="sorting_disabled" style={{ width: "1%" }}>
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                />
              </th>
              <th>Wetenschappelijke naam</th>
              <th>Nederlandse naam</th>
              <th>Wet</th>
              <th>Overige statusen</th>
              <th>Naam periode</th>
              <th>Soort</th>
              <th>Begin periode</th>
              <th>Einde periode</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
        <input id="tree-parent-name" hidden />
      </div>
    );
  }
}

export default Table;
